import React from 'react';

export default function Error() {
    return (
      <div className="error">
          <h1>That's MISTER 404 to you!</h1>
      </div>
    );
  }